import React from 'react';

export default class Propaganda extends React.Component {

    render(){

        return (
          <>


            <section className="page-section portfolio" style={{ 'marginTop' : -105 + 'px' }} id="promotion">
                <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Você chegou ao lugar certo!</h2>

                </div>
            </section>

          </>
        );
      }

}